// import React, { useState } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import './SignupPage.css';

// import { useAuth } from '../context/AuthContext';



// const SignupPage = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     username: '',
//     email: '',
//     password: '',
//     confirmPassword: ''
//   });
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const { signup } = useAuth();
//   const location = useLocation();


//   // Get redirect location if coming from search
//   const from = location.state?.from || '/login';
//   const street = location.state?.street || '';


//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     if (formData.password !== formData.confirmPassword) {
//       setError('Passwords do not match');
//       return;
//     }

//     if (formData.password.length < 8) {
//       setError('Password must be at least 8 characters');
//       return;
//     }

//     setLoading(true);

//     // try {
//     //   console.log('Signup data:', {
//     //     username: formData.username,
//     //     email: formData.email,
//     //     password: formData.password
//     //   });

//     //   await new Promise(resolve => setTimeout(resolve, 1500));

//     //   setSuccess(true);

//     //   setTimeout(() => {
//     //     navigate('/login');
//     //   }, 2000);
//     // } catch (err) {
//     //   setError('Signup failed. Please try again.');
//     // } finally {
//     //   setLoading(false);
//     // }






//     try {
//       const result = await signup(formData);

//       if (result.success) {
//         console.log('Signup successful:', result);
//         // Redirect to analysis if coming from search
//         if (street) {
//           console.log('Redirecting to analysis with street:', street);
//           navigate(`/analysis?street=${encodeURIComponent(street)}`);
//         } else {
//           navigate(from);
//         }
//       } else {
//         setError(result.message || 'Signup failed');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };




//   return (
//     <div className="signup-container">
//       <div className="signup-header">
//         <h1 className="logo">Amenity<span className="logo-highlight">Scores</span></h1>
//         <h2>Create Your Account</h2>
//         <p>Get access to comprehensive property insights</p>
//       </div>

//       <div className="signup-card">
//         {success ? (
//           <div className="success-container">
//             <div className="success-icon">
//               <svg className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//               </svg>
//             </div>
//             <h3>Account Created Successfully!</h3>
//             <p>You’ll be redirected to login shortly.</p>
//             <div className="progress-bar">
//               <div className="progress-bar-fill animate-pulse"></div>
//             </div>
//           </div>
//         ) : (
//           <>
//             {error && <div className="error-message">{error}</div>}

//             <form className="signup-form" onSubmit={handleSubmit}>
//               <div className="form-group">
//                 <label htmlFor="username">Username</label>
//                 <input
//                   id="username"
//                   name="username"
//                   type="text"
//                   required
//                   value={formData.username}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="email">Email Address</label>
//                 <input
//                   id="email"
//                   name="email"
//                   type="email"
//                   required
//                   value={formData.email}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-group">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   id="password"
//                   name="password"
//                   type="password"
//                   required
//                   value={formData.password}
//                   onChange={handleChange}
//                 />
//                 <small>Must be at least 8 characters</small>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="confirmPassword">Confirm Password</label>
//                 <input
//                   id="confirmPassword"
//                   name="confirmPassword"
//                   type="password"
//                   required
//                   value={formData.confirmPassword}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-group checkbox">
//                 <input
//                   id="terms"
//                   name="terms"
//                   type="checkbox"
//                   required
//                 />
//                 <label htmlFor="terms">
//                   I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
//                 </label>
//               </div>

//               <button type="submit" disabled={loading}>
//                 {loading ? (
//                   <>
//                     <svg className="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="spinner-bg" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                       <path className="spinner-fg" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z" />
//                     </svg>
//                     Creating Account...
//                   </>
//                 ) : 'Create Account'}
//               </button>
//             </form>

//             <div className="divider">
//               <span>Already have an account?</span>
//             </div>

//             <div className="login-link">
//               <Link to="/login">Sign in to your account</Link>
//             </div>
//           </>
//         )}
//       </div>

//       <div className="signup-footer">
//         <p>© {new Date().getFullYear()} Amenity Scores. All rights reserved.</p>
//       </div>
//     </div>
//   );
// };

// export default SignupPage;




import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './SignupPage.css';

import { useAuth } from '../context/AuthContext';

const SignupPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { signup } = useAuth();
  const location = useLocation();

  // Get redirect location if coming from search
  const from = location.state?.from || '/login';
  const street = location.state?.street || '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    try {
      const result = await signup(formData);

      if (result.success) {
        console.log('Signup successful:', result);
        // Redirect to analysis if coming from search
        if (street) {
          console.log('Redirecting to analysis with street:', street);
          navigate(`/analysis?street=${encodeURIComponent(street)}`);
        } else {
          navigate(from);
        }
      } else {
        setError(result.message || 'Signup failed');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <h1 className="logo">Amenity<span className="logo-highlight">Scores</span></h1>
        <h2>Create Your Account</h2>
        <p>Get access to comprehensive property insights</p>
      </div>

      <div className="signup-card">
        {success ? (
          <div className="success-container">
            <div className="success-icon">
              <svg className="icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3>Account Created Successfully!</h3>
            <p>You’ll be redirected to login shortly.</p>
            <div className="progress-bar">
              <div className="progress-bar-fill animate-pulse"></div>
            </div>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            <form className="signup-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  required
                  value={formData.username}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
                <small>Must be at least 8 characters</small>
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  required
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              <div className="terms-container">
                <div className="custom-checkbox">
                  <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    required
                  />
                  <span className="checkmark"></span>
                </div>
                <label htmlFor="terms" className="terms-label">
                  I agree to the <Link to="/terms-of-service" className="terms-link">Terms of Service</Link> and <Link to="/privacy-policy" className="terms-link">Privacy Policy</Link>
                </label>
              </div>

              <button 
                type="submit" 
                disabled={loading}
                className="submit-btn"
              >
                {loading ? (
                  <>
                    <svg className="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="spinner-bg" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="spinner-fg" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Creating Account...
                  </>
                ) : 'Create Account'}
              </button>
            </form>

            <div className="divider">
              <span>Already have an account?</span>
            </div>

            <div className="login-link">
              <Link to="/login">Sign in to your account</Link>
            </div>
          </>
        )}
      </div>

      <div className="signup-footer">
        <p>© {new Date().getFullYear()} Amenity Scores. All rights reserved.</p>
      </div>
    </div>
  );
};

export default SignupPage;